import { useQuery } from '@tanstack/react-query';

import { seasonDivisionPoolKeys } from '@/hooks/leagueSeasonDivision/seasonDivisionPoolKeys';
import { getSeasonDivisionPool } from '@/infrastructure/network/data/season-divisions/season-division-pool';

export const useSeasonDivisionPool = (seasonDivisionUuid: string) => {
	return useQuery({
		queryKey: seasonDivisionPoolKeys.pool(seasonDivisionUuid),
		queryFn: () => getSeasonDivisionPool({ seasonDivisionUuid }),
		enabled: !!seasonDivisionUuid
	});
};
